import React from 'react'

import {Typography, Box} from "@material-ui/core"

import {useStyles} from '../../themes/styles'

const Home = (props) => {
  const classes = useStyles()

  return ( <>
    <Box className={classes.spacing}>
      <Typography variant="h2" align="center" className={classes.fontScript}>Our Story Song</Typography>
      <Typography variant="h4" align="center" className={classes.fontScript0}>Every Story Deserves a Song</Typography>
    </Box>
  </> )
}

export default Home
